// Cálculos puros dos gráficos de painel — sem React, testados em calculos.test.js.

// Escala ABSOLUTA a partir de zero: cada parte vira % de um máximo comum a todas
// as barras do bloco. Barra 100% (proporção) faz Angra (23) e Nhangapi (72)
// parecerem do mesmo tamanho — e a pergunta da chefia é "quanto tenho onde".
export const larguras = (partes, max) => {
  if (!max) return partes.map(() => 0);
  return partes.map((n) => (100 * (Number(n) || 0)) / max);
};

// Mantém os N maiores e junta o resto em "Outros". Se o resto for um item só,
// mostra o próprio item: "Outros (1)" esconde informação sem ganhar espaço.
export const agrupaTopN = (itens, topN, rotuloOutros) => {
  const ordenados = [...itens].sort((a, b) => b.n - a.n);
  if (ordenados.length <= topN + 1) return ordenados;
  const resto = ordenados.slice(topN);
  return [
    ...ordenados.slice(0, topN),
    { rotulo: rotuloOutros, n: resto.reduce((s, i) => s + i.n, 0), outros: true, quantos: resto.length },
  ];
};

// Um item que passa do limiar do total vira frase ("Agente: 254 (90%)"):
// uma barra gigante ao lado de lascas não informa nada.
export const dominante = (itens, limiar) => {
  const total = itens.reduce((s, i) => s + i.n, 0);
  if (!total) return null;
  const maior = itens.reduce((m, i) => (i.n > m.n ? i : m), itens[0]);
  return maior.n / total > limiar ? { rotulo: maior.rotulo, n: maior.n, total } : null;
};

// Colunas verticais: total e parte na MESMA escala (o maior total = 100%).
// A parte (ex.: liquidado) é sub-conjunto do total (lavrado), então nunca passa dele.
export const alturasColunas = (itens) => {
  const max = Math.max(0, ...itens.map((i) => Number(i.total) || 0));
  if (!max) return itens.map(() => ({ total: 0, parte: 0 }));
  return itens.map((i) => {
    const total = (100 * (Number(i.total) || 0)) / max;
    return { total, parte: Math.min(total, (100 * (Number(i.parte) || 0)) / max) };
  });
};
